import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Badge } from '@/components/ui/badge';
import { BUSINESS_UNITS, BUSINESS_UNIT_LABELS, BusinessUnit } from '@/constants/businessUnits';

interface Props {
  value: BusinessUnit | '' | undefined;
  onValueChange: (v: BusinessUnit) => void;
  includeAll?: boolean;
  allLabel?: string;
  placeholder?: string;
  className?: string;
}

export const BusinessUnitSelect: React.FC<Props> = ({
  value, onValueChange, includeAll, allLabel = 'All Business Units', placeholder = 'Select business unit', className,
}) => (
  <Select value={value || (includeAll ? '__all__' : '')} onValueChange={(v) => onValueChange(v === '__all__' ? ('' as any) : (v as BusinessUnit))}>
    <SelectTrigger className={className}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>
      {includeAll && <SelectItem value="__all__">{allLabel}</SelectItem>}
      {BUSINESS_UNITS.map(bu => (
        <SelectItem key={bu.value} value={bu.value}>{bu.label}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export const BusinessUnitBadge: React.FC<{ value?: BusinessUnit | string | null }> = ({ value }) => {
  if (!value) return <span className="text-muted-foreground text-xs">—</span>;
  const label = BUSINESS_UNIT_LABELS[value as BusinessUnit] ?? value;
  const color = BUSINESS_UNITS.find(b => b.value === value)?.color ?? 'hsl(var(--muted-foreground))';
  return (
    <Badge variant="outline" style={{ borderColor: color, color }}>
      {label}
    </Badge>
  );
};
